import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../components/Breadcrumb";
import "../styles/DocumentosPaciente.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function DocumentosPaciente() {
    const { expediente } = useParams();
    const [documentos, setDocumentos] = useState([]);
    const [paciente, setPaciente] = useState(null);

    // Paciente
    useEffect(() => {
        axios.get(`/api/pacientes/${expediente}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        })
        .then(res => setPaciente(res.data))
        .catch(() => toast.error("Error al cargar paciente"));
    }, [expediente]);

    // Documentos
    useEffect(() => {
        axios.get(`/api/documentos/${expediente}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        })
        .then(res => setDocumentos(res.data))
        .catch(() => toast.error("Error al cargar documentos"));
    }, [expediente]);

    const descargar = async (id, nombre) => {

        const res = await axios.get(`/api/documentos/${id}/download`, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });

        const url = window.URL.createObjectURL(new Blob([res.data]));

        const link = document.createElement("a");
        link.href = url;
        link.download = nombre;
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    return (
        <>
            <ToastContainer />

            <div className="documentos-page">
                <Breadcrumb />
                <h2>
                    Documentos del paciente{" "}
                    {paciente
                        ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                            .filter(Boolean)
                            .join(" ")
                        : expediente}
                </h2>

                <table className="tabla-documentos">
                    <thead>
                        <tr>
                            <th>Documento</th>
                            <th>Tipo</th>
                            <th>Firmado</th>
                            <th>Fecha firma</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {documentos.length === 0 && (
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                    No hay documentos
                                </td>
                            </tr>
                        )}

                        {documentos.map(doc => (
                            <tr key={doc.id}>
                                <td>{doc.nombreDocumento}</td>
                                <td>{doc.tipo}</td>
                                <td>
                                    <span className={doc.firmado ? "color-si" : "color-no"}>
                                        {doc.firmado ? "Sí" : "No"}
                                    </span>
                                </td>
                                <td>
                                    {doc.fechaFirma
                                        ? new Date(doc.fechaFirma).toLocaleDateString("es-ES")
                                        : "-"}
                                </td>
                                <td>
                                    <button
                                        className="btn-descargar"
                                        onClick={() => descargar(doc.id, doc.nombreDocumento)}
                                    >
                                        Descargar
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}
